import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  gpsDenied,
  gpsGranted,
  motionDenied,
  motionGranted,
  webcamDenied,
  webcamGranted,
} from '@src/redux/reducer/device.ts'
import { useMemo } from 'react'
import { Howl } from 'howler'
import SilenceSound from '@static/media/sounds/silence_1s.mp3'
import { getLocationSuccess } from '@src/redux/reducer/gps.ts'
import permissionList from '@src/hook/PermissinList.tsx'

type PermissionType = 'camera' | 'gps' | 'motion'

const usePermission = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  /** sound가 있는 콘텐츠에서 iOS의 유저인터랙션을 위해 버튼 클릭시 1초짜리 무음 mp3 재생 */
  const sound = useMemo(() => {
    return new Howl({ src: SilenceSound, html5: true, preload: true })
  }, [])

  /** [개발용] 모든 권한 한번에 요청 & 획득하기 */
  const requestAllPermission = () => {
    permissionList.camera.request(onCameraGranted, onCameraFailed)
    permissionList.gps.request(onGpsGranted, onGpsFailed)
    permissionList.motion.request(onMotionGranted, onMotionFailed)
  }

  const requestPermission = (permissions: PermissionType[]) => {
    if (permissions.includes('camera')) {
      permissionList.camera.request(onCameraGranted, onCameraFailed)
    }

    if (permissions.includes('gps')) {
      permissionList.gps.request(onGpsGranted, onGpsFailed)
    }

    if (permissions.includes('motion')) {
      permissionList.motion.request(onMotionGranted, onMotionFailed)
    }
  }

  /** 버튼 클릭시 무음 사운드 재생 및 권한 순차적 획득 */
  // const onClickRequireButton = async () => {
  //   if (isClicked) return
  //   setIsClicked(true)
  //   // sound가 있는 콘텐츠에서 iOS의 유저인터랙션을 위해 버튼 클릭시 1초짜리 무음 mp3 재생
  //   sound.play()
  //   // 모션센서부터 권한 획득하기
  //   await permissionList.motion.request(onMotionGranted, onMotionFailed)
  // }

  /** 각 권한 요청 성공 및 실패 시 처리 함수들 */
  const onMotionGranted = async () => {
    console.log('[permission] 모션 센서 권한 획득')
    dispatch(motionGranted())
    await permissionList.gps.request(onGpsGranted, onGpsFailed)
  }
  const onMotionFailed = (e: any) => {
    console.log('[permission] 모션 센서 권한 거절')
    console.error(e)
    dispatch(motionDenied())
    const state = { prevPath: location.pathname }
    navigate(`/error/motion-sensor`, { state })
  }

  const onGpsGranted = async (pos: any) => {
    console.log('[permission] GPS 권한 획득')
    const payload = { lat: pos.coords.latitude, lng: pos.coords.longitude, isTravel: false }
    dispatch(getLocationSuccess(payload))
    dispatch(gpsGranted())
    // await permissionList.camera.request(onCameraGranted, onCameraFailed)
  }
  const onGpsFailed = (e: any) => {
    console.log('[permission] GPS 권한 거절')
    console.error(e)
    dispatch(gpsDenied())
    const state = { prevPath: location.pathname }
    navigate(`/error/gps-sensor`, { state })
  }
  const onCameraGranted = () => {
    console.log('[permission] 카메라 권한 획득')
    dispatch(webcamGranted())
  }
  const onCameraFailed = (e: any) => {
    console.log('[permission] 카메라 권한 거절')
    console.error(e)
    dispatch(webcamDenied())
    const state = { prevPath: location.pathname }
    navigate(`/error/camera-sensor`, { state })
  }

  return { requestAllPermission, requestPermission }
}

export default usePermission
